export const PRIVACY_POLICY_TEXT = `Useless(이하 '회사'라 한다)는 개인정보 보호법 제30조에 따라 정보 주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리지침을 수립, 공개합니다.

제1조 (개인정보의 처리목적)
회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

1. 홈페이지 회원 가입 및 관리
회원 가입 의사 확인, 회원제 서비스 제공에 따른 본인 식별․인증, 회원자격 유지․관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정 이용 방지, 만 14세 미만 아동의 개인정보처리 시 법정대리인의 동의 여부 확인, 각종 고지․통지, 고충 처리 등을 목적으로 개인정보를 처리합니다.

2. 재화 또는 서비스 제공
물품 배송, 서비스 제공, 계약서 및 청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금 결제 및 정산, 채권추심 등을 목적으로 개인정보를 처리합니다.

3. 고충 처리
민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락․통지, 처리 결과 통보 등의 목적으로 개인정보를 처리합니다.

제2조 (개인정보의 처리 및 보유기간)
① 회사는 법령에 따른 개인정보 보유, 이용 기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유, 이용 기간 내에서 개인정보를 처리, 보유합니다.
② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.

1. 홈페이지 회원 가입 및 관리 : 사업자/단체 홈페이지 탈퇴 시까지
다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지
1 관계 법령 위반에 따른 수사, 조사 등이 진행 중인 경우에는 해당 수사, 조사 종료 시까지
2 홈페이지 이용에 따른 채권 및 채무관계 잔존 시에는 해당 채권, 채무 관계 정산 시까지

제4조(개인정보처리의 위탁)
① 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
- 위탁업무 내용
- 위탁받는 자 (수탁자) : Google Cloud (Firebase)
- 위탁하는 업무의 내용 : 서버 운영 및 데이터 저장, 사용자 인증, 서비스 이용 통계 분석(Firebase Analytics), 푸시 알림 발송(Firebase Cloud Messaging)
- 보유 및 이용기간 : 회원 탈퇴 시 또는 위탁계약 종료 시까지
- 위탁받는 자 (수탁자) : RevenueCat, Inc.
- 위탁하는 업무의 내용 : 모바일 앱 유료 구독(광고 제거)의 구매 검증, 구독 상태(갱신·해지·만료) 관리
- 이전 국가 및 방법 : 미국, 구매·구독 상태 확인 시점에 네트워크를 통해 전송
- 이전 항목 : 회원 식별자(Firebase UID), 구독 상품, 구매·갱신·만료 시각, 스토어 거래 식별자, 기기 정보(OS, 앱 버전)
- 보유 및 이용기간 : 회원 탈퇴 시 또는 위탁계약 종료 시까지
② 회사는 위탁계약 체결 시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.

제4조의2(광고를 위한 개인정보의 제3자 제공 및 국외 이전)
① 회사의 모바일 앱은 앱 내 광고를 게재하기 위해 Google LLC의 광고 서비스(Google AdMob)를 이용하며, 이 과정에서 제6조 제4호의 정보가 Google LLC에 제공됩니다.
- 제공받는 자 : Google LLC
- 제공 목적 : 앱 내 광고 게재, 관심사 기반 맞춤 광고 제공, 광고 성과 측정 및 부정 이용 방지
- 제공 항목 : 광고 식별자(iOS IDFA, Android 광고 ID), 광고 노출·클릭 기록, 기기 정보(모델, OS, 언어), IP 주소, 광고 동의 상태
- 이전 국가 및 방법 : 미국, 앱 이용 시점에 네트워크를 통해 전송
- 보유 및 이용기간 : Google 개인정보처리방침(https://policies.google.com/privacy)에 따름
② iOS에서는 앱 추적 투명성(ATT) 요청을 허용한 경우에만 광고 식별자(IDFA)가 제공되며, 허용하지 않으면 맞춤형이 아닌 광고가 표시됩니다. 유럽경제지역·영국·스위스 등 법령상 동의가 필요한 지역에서는 광고를 표시하기 전에 동의를 먼저 받습니다.
③ 이용자는 언제든지 다음 방법으로 맞춤 광고를 거부하거나 동의를 변경할 수 있으며, 거부하더라도 앱의 모든 기능을 그대로 이용할 수 있습니다.
- iOS : 설정 > 개인정보 보호 및 보안 > 추적에서 앱의 추적 허용 해제
- Android : 설정 > 개인정보 보호 > 광고에서 광고 ID 삭제 또는 재설정
- 앱 설정 화면의 '광고 개인정보 설정'(동의가 필요한 지역에 한해 표시)
④ 회원 정보(이메일주소 등)와 건강 데이터(제11조)는 광고에 사용하지 않으며 Google LLC에 제공하지 않습니다. 웹 서비스에는 광고를 게재하지 않습니다.

제5조(정보주체 및 법정대리인의 권리와 그 행사 방법)
① 정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
1. 개인정보 열람 요구
2. 오류 등이 있을 경우 정정 요구
3. 삭제요구
4. 처리정지 요구
② 제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체없이 조치하겠습니다.
③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.
④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
⑤ 정보주체는 개인정보 보호법 등 관계 법령을 위반하여 회사가 처리하고 있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니 됩니다.

제6조(처리하는 개인정보 항목)
회사는 다음의 개인정보 항목을 처리하고 있습니다.
1. 회원 가입 및 관리
필수항목 : 이메일주소, Google UID
2. 서비스 이용 과정에서 자동 수집되는 항목
- 수집항목 : 기기 식별자(Firebase 앱 인스턴스 ID, 푸시 알림 토큰), 앱 이용 기록(화면 조회·기능 사용 이벤트), 앱 버전 및 OS 정보
- 수집목적 : 서비스 이용 통계 분석 및 품질 개선, 푸시 알림 발송
- 보유기간 : 회원 탈퇴 시 또는 앱 삭제 시까지

3. 운동 기록 연결 기능 이용 시 (선택)
선택항목 : 건강 데이터 요약(운동 식별자, 총 이동 거리, 총 소요 시간, 누적 상승고도, 활동 에너지, 연결 시각) — 자세한 내용은 제11조 참조
4. 모바일 앱 광고 제공 과정에서 자동 수집되는 항목
- 수집항목 : 광고 식별자(iOS IDFA — 앱 추적 허용 시에 한함, Android 광고 ID), 광고 노출·클릭 기록, 기기 정보(모델, OS, 언어), IP 주소, 광고 동의 상태
- 수집목적 : 앱 내 광고 게재, 관심사 기반 맞춤 광고 제공, 광고 성과 측정 및 부정 이용 방지
- 보유기간 : 앱 삭제 시 또는 이용자가 광고 식별자를 재설정·삭제할 때까지(Google LLC에 제공된 정보는 제4조의2에 따름)
5. 유료 구독(광고 제거) 이용 시
- 수집항목 : 구독 상품, 구매·갱신·해지·만료 시각, 구독 상태, 결제 스토어(App Store·Google Play) 및 스토어 거래 식별자, 결제 환경(실결제·테스트)
- 수집목적 : 구독 혜택(광고 제거) 제공, 구독 상태 확인, 구매 복원, 고객 문의 대응, 서비스 운영 통계
- 보유기간 : 회원 탈퇴 시까지. 다만 전자상거래 등에서의 소비자보호에 관한 법률에 따라 대금결제 및 재화 등의 공급에 관한 기록은 5년간 보관합니다.
- 결제는 Apple(App Store)·Google(Google Play)이 처리하며, 회사는 카드번호 등 결제수단 정보를 수집하지 않습니다.

제7조(개인정보의 파기)
① 회사는 개인정보 보유 기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
② 정보주체로부터 동의받은 개인정보 보유 기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.
③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.
1. 파기 절차
회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
2. 파기 방법
회사는 전자적 파일 형태로 기록․저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록․저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.

제8조(개인정보의 안전성 확보조치)
회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 하고 있습니다.
1. 관리적 조치 : 내부관리계획 수립 및 시행, 정기적 직원 교육 등
2. 기술적 조치 : 개인정보처리시스템 등의 접근 권한 관리, 접근통제시스템 설치, 고유 식별정보 등의 암호화, 보안프로그램 설치
3. 물리적 조치 : 전산실, 자료보관실 등의 접근통제

제9조(개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항)
① 회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.
② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에 보내는 소량의 정보이며 이용자들의 PC 또는 모바일에 저장됩니다.
③ 정보주체는 웹 브라우저 옵션 설정을 통해 쿠키 허용, 차단 등의 설정을 할 수 있습니다. 다만, 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.
▶ 웹 브라우저에서 쿠키 허용/차단
- 크롬(Chrome) : 웹 브라우저 설정 > 개인정보 보호 및 보안 > 인터넷 사용기록 삭제
- 엣지(Edge) : 웹 브라우저 설정 > 쿠키 및 사이트 권한 > 쿠키 및 사이트 데이터 관리 및 삭제
▶ 모바일 브라우저에서 쿠키 허용/차단
- 크롬(Chrome) : 모바일 브라우저 설정 > 개인정보 보호 및 보안 > 인터넷 사용기록 삭제
- 사파리(Safari) : 모바일 기기 설정 > 사파리(Safari) > 고급 > 모든 쿠키 차단
- 삼성 인터넷 : 모바일 브라우저 설정 > 인터넷 사용 기록 > 인터넷 사용 기록 삭제
④ 회사는 서비스 이용과정에서 사용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 수집・이용하고 있습니다.

제10조(개인정보 보호책임자)
① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만 처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
▶ 개인정보 보호책임자
성명 : 서진용
직책 : 매니저
연락처 : 010-4900-6586
※ 개인정보 보호 담당부서로 연결됩니다.
▶ 개인정보 보호 담당부서
부서명 : 운영팀
연락처 : 010-4900-6586
② 정보주체께서는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만 처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.

제11조(건강 데이터의 처리)
① 회사의 모바일 앱은 이용자가 배낭(여행) 기록에 운동 기록을 연결해 볼 수 있는 기능을 제공하기 위해, 이용자의 명시적인 동의(기기 권한 허용)를 받아 기기의 건강 플랫폼(Apple 건강/HealthKit, Android 헬스 커넥트/Health Connect)에서 다음 건강 데이터에 접근하여 읽습니다.
1. 운동 기록: 운동 종류, 시작·종료 시각, 소요 시간
2. 이동 거리, 누적 상승고도, 활동 에너지(칼로리)
3. 심박수, 운동 경로(GPS 좌표) — 화면 표시 목적
② 심박수와 운동 경로(GPS 좌표) 등 상세 데이터는 표시 시점에 이용자 기기에서만 조회·표시되며, 회사 서버로 전송하거나 저장하지 않습니다.
③ 이용자가 운동 기록을 배낭에 연결한 경우에 한하여, 해당 운동의 식별자(참조값)와 요약 정보(총 이동 거리, 총 소요 시간, 누적 상승고도, 활동 에너지, 연결 시각)만 이용자 계정 데이터로 서버(Google Cloud Firebase)에 저장됩니다.
④ 건강 데이터는 위 목적(이용자 본인에게 운동 기록을 표시) 외의 용도로 사용하지 않으며, 제3자에게 제공하지 않고 광고 등 다른 목적으로도 사용하지 않습니다.
⑤ 이용자는 기기 설정(iOS: 설정 > 개인정보 보호 및 보안 > 건강, Android: 헬스 커넥트 > 앱 권한)에서 언제든지 접근 권한을 철회할 수 있습니다. 배낭에서 운동 연결을 해제하면 저장된 요약 정보는 삭제되며, 회원 탈퇴 시 모든 개인정보와 함께 파기됩니다(제7조).

부칙
이 개인정보처리방침은 2026년 9월 27일부터 적용됩니다.`;
